module.exports = __webpack_public_path__ + "img/48.558161b6.jpg";